import {
  listItemWrapper,
  listWrapper,
  pagedListWrapper
} from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { Category, Product, Order } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const { getItem: getCategory } = listItemWrapper<Category>(apiClient, {
      path: `/api/v${version}/store/categories`,
      requestOptions: {
        cache: {
          ttl: 60000 // 1m
        }
      }
    })

    const categories = pagedListWrapper<'id', Category>()(apiClient, {
      path: `/api/v${version}/store/categories`,
      idKey: 'id',
      requestOptions: {
        cache: {
          ttl: 60000 // 1m
        }
      }
    })

    const { getItem: getProduct } = listItemWrapper<Product>(apiClient, {
      path: `/api/v${version}/store/products`
    })

    const products = pagedListWrapper<'id', Product>()(apiClient, {
      path: `/api/v${version}/store/products`,
      idKey: 'id'
    })

    const orders = pagedListWrapper<'id', Order>()(apiClient, {
      path: `/api/v${version}/store/orders`,
      idKey: 'id'
    })

    const orderList = listWrapper<'id', Order>(apiClient, {
      path: `/api/v${version}/store/orders/list`,
      idKey: 'id'
    })

    return {
      getCategory,
      categories,
      getProduct,
      products,
      orders,
      orderList,

      buyProduct: (id: Product['id']) =>
        apiClient.post<Order>(`/api/v${version}/store/products/${id}/buy`)
    }
  }
} satisfies Starter
